import { PERMISSIONS } from "@/rbac/permissions.js";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";

const VIEW_PERMISSIONS = [
  PERMISSIONS.ROLE_BMS_INSPECTOR_SUPERVISOR,
  PERMISSIONS.ROLE_BMS_POWERUSER,
  PERMISSIONS.ROLE_BMS_SUPERUSER,
];

const EDIT_PERMISSIONS = [...VIEW_PERMISSIONS];

export const CREATE_STRUCTURE_PERMISSIONS = {
  [ACCESS_LEVELS.VIEW]: VIEW_PERMISSIONS,
  [ACCESS_LEVELS.EDIT]: EDIT_PERMISSIONS,
};
